module.exports = __webpack_public_path__ + "img/offer-live.9ecbcd37.svg";